// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_g1-0";
export var optionCard = "_g1-1";